import CustomerPageBody from "../components/customerPage/CustomerPageBody";

const CustomerPage = () => {
    return(<CustomerPageBody/>)
}

export default CustomerPage;